export * from "./helpers";
export * from "./formatters";
export * from "./links";
export * from "./web3";
export * from "./toasts";
export * from "./numbers";
export * from "./errorProcessing";
export * from "./colors";
export * from "./meta";
export { UiLabelChain } from "@/components/Ui/Label/Chain";

export const validateEmail = (value: string) => {
  return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(value);
};

export function removeFromLast<T>(path: string, key: string): string | T {
  const i = path.lastIndexOf(key);
  return i === -1 ? path : path.substring(0, i);
}

export function isFunction(fn: any): boolean {
  return typeof fn === "function";
}

export function getTimestampInSeconds() {
  return Math.floor(Date.now() / 1000);
}

export function wait(ms: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

export async function retry<R>(fn: () => Promise<R>, condition: (res: R, attempt: number) => boolean | Promise<boolean>): Promise<R | null> {
  let attempt = 1;
  let result = await fn();
  let completed = await condition(result, attempt);

  while (!completed) {
    const delayInMs = 2 ** attempt * 1000;
    attempt++;

    await wait(delayInMs);
    result = await fn();
    completed = await condition(result, 0);
  }

  return result;
}
